import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BbHamburgerOverlayComponent, HamburgerItem, HamburgerOptionSelected } from '../bb-hamburger-overlay/bb-hamburger-overlay.component';

@Component({
	selector: 'bb-tile',
	templateUrl: './bb-tile.component.html',
	styleUrls: ['./bb-tile.component.scss']
})

export class BbTileComponent implements OnInit, OnChanges {
	@Input() loading = false;
	@Input() noPadding = false;
	@Input() menuOptions: HamburgerItem[];
	@Input() sizing: string;
	@Input() headerBar = false;
	@Input() noData = false;
	@Input() noBorders = false;

	@Output() menuOptionSelected: EventEmitter<HamburgerOptionSelected> = new EventEmitter<HamburgerOptionSelected>();

	@ViewChild(BbHamburgerOverlayComponent) hamburger: BbHamburgerOverlayComponent;

	initialised = false;
	loadingDelayed = false;

	constructor() { }

	ngOnChanges(changes: SimpleChanges) {
		if (changes && changes.loading) {
			if (!changes.loading.firstChange) {
				// loading was probably set to true and then false
				this.initialised = true;
			}
			setTimeout(() => {
				// used for animation purposes
				this.loadingDelayed = changes.loading.currentValue;
			}, 500);
		}
	}

	ngOnInit() { }

	setMenuFilter(data: HamburgerOptionSelected) {
		this.menuOptionSelected.emit(data);
	}

	toggleMenu() {
		this.hamburger.open();
	}
}
